




































import {Component, Prop, Vue} from "vue-property-decorator";
import tokens from "@/authorization/tokens";

@Component
export default class StatementMonthly extends Vue {
    @Prop() public year!: string;
    @Prop() public month!: string;
    @Prop() public charges!: [];
    @Prop() public total!: [];

    public accountId = tokens.AccountId;
}
